// import './App.css';
// // import { BrowserRouter as Router } from 'react-router-dom';

// import { Layout } from 'antd';
// import { useState } from 'react';
// import Sidebar from './JSX/layout/SideBar';
// import FooterBar from './JSX/layout/nav/FooterBar';
// import AppRoutes from './JSX/layout/nav/AppRoutes';
// import HeaderBar from './JSX/layout/HeaderBar';
// import LoginPage from './JSX/Pages/Manage/Users/LoginPage';

// const { Header, Footer, Sider, Content } = Layout;

// function App() {
//   const [collapsed, setCollapsed] = useState(false);
//   const [isMobile, setIsMobile] = useState(false);

//   const ome_token = localStorage.getItem("ome_token");
//   const ome_user = localStorage.getItem("ome_user");

//   if (!ome_token || !ome_user) {
//     return <LoginPage />;
//   }

//   return (
//     <Layout style={{
//       minHeight: '100vh',
//       overflow: 'hidden'
//     }}>
//       <Sider
//         width={250}
//         collapsedWidth={isMobile ? 0 : 80}

//         collapsed={collapsed}
//         onCollapse={(collapsed) => setCollapsed(collapsed)}
//         style={{
//           background: '#d0e0e8ff',
//           overflow: 'auto',
//           height: '100vh',
//           position: 'fixed',
//           left: 0,
//           top: 0,
//           zIndex: 100,
//         }}
//       >
//         <Sidebar
//           collapsed={collapsed}
//           setCollapsed={setCollapsed}
//           isMobile={isMobile}
//           setIsMobile={setIsMobile}
//         />
//       </Sider>

//       {/* Main Content Area */}
//       <Layout style={{
//         marginLeft: collapsed ? (isMobile ? 0 : 80) : 250,
//         transition: 'margin-left 0.2s',
//       }}>
//         <Header style={{ backgroundColor: '#d8ecff41', padding: 0 }}>
//           <HeaderBar />

//         </Header>

//         <Content style={{
//           margin: '10px',
//           padding: '5px',
//           lineHeight: '0',
//           // background: '#fff',
//           borderRadius: 8,
//           height: 'calc(100vh - 28px)',
//           overflow: 'auto',
//           scrollbarWidth: 'none',
//           msOverflowStyle: 'none',
//         }}>

//           <style> {`::-webkit-scrollbar { display: none;}`}</style>
//           <AppRoutes />
//         </Content>

//         <Footer style={{
//           textAlign: 'center',
//           padding: '0',
//           margin: '0',
//           lineHeight: '0'
//         }}>
//           <div style={{ height: '100%' }}>
//             <FooterBar />
//           </div>
//         </Footer>
//       </Layout>
//     </Layout>
//   );
// }

// export default App;

import { Layout } from "antd";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import AppRoutes from "./JSX/layout/nav/AppRoutes";
import TopHeader from "./JSX/layout/TopHeader";
import SubMenuBar from "./JSX/layout/SubMenuBar";
import FooterBar from "./JSX/layout/nav/FooterBar";
import LoginPage from "./JSX/Pages/Manage/Users/LoginPage";
import { MenuList } from "./JSX/layout/nav/MenuList";
import { findMenuFromPath } from "./JSX/components/CustomView/menuUtils";

const { Content, Footer } = Layout;

function App() {
  const location = useLocation();
  const [activeParent, setActiveParent] = useState(null);

  const ome_token = localStorage.getItem("ome_token");
  const ome_user = localStorage.getItem("ome_user");

  useEffect(() => {
    const { parent } = findMenuFromPath(MenuList, location.pathname);
    setActiveParent(parent);
  }, []);

  if (!ome_token || !ome_user) {
    return <LoginPage />;
  }

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <TopHeader
        activeParent={activeParent}
        setActiveParent={setActiveParent}
      />

      <SubMenuBar activeParent={activeParent} />

      <Content
        style={{
          margin: 10,
          paddingTop: 5,
          background: "#f7f9fc",
        }}
      >
        <AppRoutes />
      </Content>

      {/* <Footer style={{ textAlign: "center" }}> */}
        <FooterBar />
      {/* </Footer> */}
    </Layout>
  );
}

export default App;
